export const buildingType = [
  { value: 'House', label: 'House' },
  { value: 'Flat/Apartment', label: 'Flat/Apartment' },
  { value: 'Townhouse/Security Estate', label: 'Townhouse/Security Estate' },
  { value: 'Office', label: 'Office' }
];